import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import Button from "../../Common/Button";
import AutoCompleteSelect from "../../Common/AutoCompleteSelect";
import { setSnackBar } from "../../../store/common/commonSlice";
import { useUpdateGalleryMutation } from "../../../store/masters/mastersApis";

const defaultInitialValues = {
    _id: "",
    title: "",
    folder_id: "",
};

export const PhotoGalleryAssignDialog = ({
    show,
    close,
    initialValues = defaultInitialValues,
    folderOptions = [],
}) => {
    const dispatch = useDispatch();
    const [updateGallery, { isLoading }] = useUpdateGalleryMutation();

    const handleSubmitForm = async (values) => {
        try {
            await updateGallery({
                _id: values._id,
                title: values.title || "",
                folder_id: values.folder_id || "",
            }).unwrap();

            dispatch(
                setSnackBar({
                    open: true,
                    message: values.folder_id
                        ? "Photo folder updated successfully"
                        : "Photo folder assignment cleared successfully",
                    severity: "success",
                }),
            );
            close();
        } catch (error) {
            dispatch(
                setSnackBar({
                    open: true,
                    message: error?.data?.message || error.message,
                    severity: "error",
                }),
            );
        }
    };

    return (
        <Formik
            initialValues={{ ...defaultInitialValues, ...initialValues }}
            onSubmit={handleSubmitForm}
            enableReinitialize
        >
            {({ handleChange, handleSubmit, values, setFieldValue }) => (
                <Dialog open={show} onClose={close} fullWidth maxWidth="sm">
                    <DialogTitle>Assign Folder</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item xs={12}>
                                <Typography variant="body2" color="text.secondary">
                                    Assign this existing gallery item to a folder without creating it again.
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <AutoCompleteSelect
                                    id="assign-folder-select"
                                    options={folderOptions}
                                    label="Select Folder"
                                    onChange={(e, val) => setFieldValue("folder_id", val?.value || "")}
                                    value={
                                        folderOptions.find((option) => option.value === values?.folder_id) || null
                                    }
                                    name="folder_id"
                                    keyname="label"
                                    disableCloseOnSelect={false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Quick Action"
                                    value={values.folder_id ? "assigned" : "unassigned"}
                                    onChange={(e) => {
                                        if (e.target.value === "unassigned") {
                                            setFieldValue("folder_id", "");
                                        }
                                    }}
                                >
                                    <MenuItem value="assigned">Keep assigned</MenuItem>
                                    <MenuItem value="unassigned">Clear folder assignment</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Title"
                                    value={values.title || ""}
                                    onChange={handleChange("title")}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button type="button" color="warning" onClick={close}>
                            Cancel
                        </Button>
                        <Button type="submit" loading={isLoading} onClick={handleSubmit}>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Formik>
    );
};
